<template>
  <div class="page-content" v-if="loading">
    <spinner variant="success" />
  </div>
</template>

<script src="./TokenLogin.js"></script>